import { Reveal, Eyebrow } from "./Reveal";

export const PageHero = ({ eyebrow, title, lead, color = "#45ADE0", children, testid = "page-hero" }) => (
  <section data-testid={testid} className="relative bg-ink text-white pt-32 lg:pt-40 pb-16 lg:pb-20 overflow-hidden grain">
    <div className="absolute -right-10 top-24 hidden md:flex flex-col gap-5 opacity-[0.06]" aria-hidden="true">
      <span className="h-12 w-72 bg-white" /><span className="h-12 w-44 bg-white" /><span className="h-12 w-72 bg-white" />
    </div>
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <Eyebrow color={color} light>{eyebrow}</Eyebrow>
        <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.02] max-w-4xl">{title}</h1>
        {lead && <p className="mt-6 text-base md:text-lg text-white/70 max-w-2xl leading-relaxed">{lead}</p>}
      </Reveal>
      {children}
    </div>
    <span className="absolute bottom-0 left-0 h-[6px] w-1/3" style={{ background: color }} />
  </section>
);
